import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import PageHead from 'bdvp-common/src/components/Head';
import { getEmbedUrl, DateUtils } from 'bdvp-common/src/utils';

export const buildPageTitle = (data = {}, locale = 'en') => {

    const newTitle = _get(data, 'title', data.blurb) || '';

    const date = data.date ? DateUtils.formatDate(data.date, locale, 'short') : '';

    return `${newTitle}${date ? ` | ${date}` : ''}`;

};

export const extractPlaybackUrl = (data = {}, config = {}) => {

    let playbackUrl = '';
    const playbacks = _get(data, 'playbacks', []);
    const playbackScenarios = _get(config, 'playbackPagePlayer.mediaConfig.global.preferredPlaybackScenarios', []);

    /** pick playback format by preferred scenario */
    playbackScenarios.some(playbackScenario => {

        let playback = playbacks.find(playback => playback.name === playbackScenario);
        if (playback) {

            playbackUrl = _get(playback, 'url');

        }
        return playback;

    });

    return playbackUrl;

};

const Head = ({
    config,
    lang,
    mediaItem,
}) => {

    const embedUrl = getEmbedUrl(mediaItem, config);
    const imgCut = _get(mediaItem, 'image.cuts', []).find(cut => cut.width >= 1536);
    const shareImage = _get(imgCut, 'src', _get(config, 'shareConfig.defaultShareImg', ''));

    return (
        <PageHead
            title={buildPageTitle(mediaItem, lang)}
            description={mediaItem.description}
            structuredData={{
                '@context': 'https://schema.org',
                '@type': 'VideoObject',
                name: mediaItem.title,
                description: mediaItem.description,
                thumbnailUrl: shareImage,
                uploadDate: mediaItem.date,
                duration: DateUtils.durationToISOString(mediaItem.duration),
                contentUrl: extractPlaybackUrl(mediaItem, config),
                embedUrl: embedUrl,
            }}
            shareImage={shareImage}
            twitterCardData={{
                type: 'player',
                player: {
                    src: embedUrl,
                    width: _get(config, 'shareConfig.embedCode.width', '560'),
                    height: _get(config, 'shareConfig.embedCode.height', '315'),
                },
            }}
        />
    );

};

Head.propTypes = {
    config: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    mediaItem: PropTypes.object.isRequired,
};

export default Head;
